/* eslint-disable react/prop-types */
import React from "react"
import _ from "underscore"
import Icon from "components/planning_center_icon"
import classnames from "classnames"
import pcoURL from "@planningcenter/url"
import { ComboBox } from "components/ui"
import { Button, StackView } from "@planningcenter/tapestry-react"
import sortBy from "utils/sorter"
import AttendeeRestrictionSelector from "components/admin/AttendeeRestrictionSelector"

class FormForm extends React.Component {
  constructor(props) {
    super(props)
  }

  componentWillUnmount() {
    this.props.onCancelClick()
  }

  render() {
    const {
      editMode = false,
      peopleForms,
      event: { hasAddOns, hasAttendeeTypes, addOns = [], attendeeTypes = [] } = {},
      form: {
        active = true,
        attachment,
        formType = "people",
        hasRestrictionsOnAddOns,
        hasRestrictionsOnAttendeeTypes,
        name,
        visibleToAddOnIds = {},
        visibleToAttendeeTypeIds = {},
        remoteURL
      } = {},
      onAddOnLimitClick = () => {},
      onAttendeeTypeLimitClick = () => {},
      onDeleteClick = () => {},
      onCancelClick = () => {},
      onSubmitClick = () => {},
      onFormTypeChange = () => {},
      onNameChange = () => {},
      onPeopleFormSelectChange = () => {},
      onPDFUpload = () => {},
      onVisibleToAddOnsChange = () => {},
      onVisibleToAttendeeTypesChange = () => {},
      onURLChange = () => {},
      isValid = false
    } = this.props

    const formTypePDF = formType === "pdf"

    return (
      <>
        {!active && (
          <div className="error-alert alert mb-2">
            This form has been deactivated or deleted in People.
            <Button
              title-="Delete from this event"
              theme="destroy"
              size="xs"
              onClick={onDeleteClick}
              marginLeft={1}
            />
          </div>
        )}
        <div className="d-f@lg max-width-center-stage">
          <div className="f-2">
            <div className="pane mb-4 mb-0@lg">
              <div className="pane__header">
                <h3 className="pane__title">Form</h3>
              </div>
              <div className="p-2 d-f g-2 fd-c fd-r@sm">
                <SmartTypeSelect
                  disabled={editMode}
                  onTypeChange={onFormTypeChange}
                  selectedType={formType}
                />
                <div>
                  <SmartFormNameField
                    disabled={editMode}
                    peopleForms={peopleForms}
                    name={name}
                    onNameChange={onNameChange}
                    onURLChange={onURLChange}
                    remoteURL={remoteURL}
                    onPeopleFormSelectChange={onPeopleFormSelectChange}
                    formType={formType}
                  />
                </div>
                {formTypePDF ? (
                  <div>
                    <div className="label mb-1">File</div>
                    {editMode ? (
                      <div id="upload-pdf-btn-text" className="truncate">
                        <a
                          target="_blank"
                          className="quiet-app-btn btn2 w-100% w-a@sm"
                          css={{ maxWidth: "140px" }}
                          href={attachment && attachment.url}
                          rel="noreferrer"
                        >
                          <div className="truncate">
                            <span className=" mr-4p p-r t-2p">
                              <Icon symbol="general#new-window" />
                            </span>
                            {attachment && attachment.name}
                          </div>
                        </a>
                      </div>
                    ) : (
                      <PDFAttachmentField attachment={attachment} onPDFUpload={onPDFUpload} />
                    )}
                  </div>
                ) : null}
              </div>
            </div>
            {!hasAttendeeTypes && !hasAddOns && this.renderControls()}
          </div>

          {(hasAttendeeTypes || hasAddOns) && (
            <div className="pl-4@lg f-1">
              <div className="pane">
                <div className="pane__header">
                  <h3 className="pane__title">Options</h3>
                </div>
                {hasAttendeeTypes && (
                  <div className="p-2" css={{ wordBreak: "break-word" }}>
                    <div className="label">Available to:</div>
                    <AttendeeRestrictionSelector
                      attendeeTypes={attendeeTypes.map(at => ({
                        ...at,
                        isAvailable: !!visibleToAttendeeTypeIds[at.id]
                      }))}
                      onCheckboxChange={e => {
                        onVisibleToAttendeeTypesChange(Number(e.target.value))
                      }}
                      hasAttendeeRestriction={hasRestrictionsOnAttendeeTypes}
                      onAttendeeRestrictionChange={onAttendeeTypeLimitClick}
                    />
                  </div>
                )}
                {hasAddOns && (
                  <div className="line p-2">
                    <input
                      type="checkbox"
                      name="add_on_limit_forms"
                      id="add_on_limit_forms"
                      className="checkbox"
                      checked={hasRestrictionsOnAddOns}
                      onChange={onAddOnLimitClick}
                    />
                    <label htmlFor="add_on_limit_forms" className="checkbox-label">
                      Only collect for certain add-ons
                    </label>

                    <div
                      className={classnames({
                        "pl-3 pt-2": true,
                        hide: !hasRestrictionsOnAddOns
                      })}
                    >
                      {addOns.map(ao => (
                        <div className="mb-1" key={ao.id}>
                          <input
                            type="checkbox"
                            name={`visible_to_add_on_ids_${ao.id}`}
                            id={`visible_to_add_on_ids_${ao.id}`}
                            className="checkbox"
                            checked={!!visibleToAddOnIds[ao.id]}
                            onChange={() => {
                              onVisibleToAddOnsChange(ao.id)
                            }}
                          />
                          <label
                            htmlFor={`visible_to_add_on_ids_${ao.id}`}
                            className="checkbox-label"
                          >
                            {ao.name}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
              {this.renderControls()}
            </div>
          )}
        </div>
      </>
    )
  }

  renderControls = () => {
    const { editMode, isValid, onDeleteClick, onSubmitClick, onCancelClick } = this.props

    return (
      <StackView axis="horizontal" distribution="end" spacing={1} marginTop={2}>
        {editMode && (
          <Button title="Delete" theme="destroy" onClick={onDeleteClick} marginRight="auto" />
        )}
        <Button title="Cancel" variant="outline" onClick={onCancelClick} />
        <Button title="Save" disabled={!isValid} theme="create" onClick={onSubmitClick} />
      </StackView>
    )
  }
}

const SmartTypeSelect = ({ disabled = false, onTypeChange, selectedType }) => {
  return (
    <div>
      <label className="mb-1" htmlFor="form_type">
        Type
      </label>
      <select
        disabled={disabled}
        css={{
          minWidth: 200,
          "@media (min-width: 600px)": { maxWidth: 300 }
        }}
        className="select"
        onChange={onTypeChange}
        id="form_type"
        defaultValue={selectedType}
      >
        <option key={"pdf"} value={"pdf"}>
          PDF form
        </option>
        <option key={"people"} value={"people"}>
          People Form
        </option>
        <option key={"url"} value={"url"}>
          Online form (URL)
        </option>
      </select>
    </div>
  )
}

const PeopleFormSelectField = ({
  disabled = false,
  name,
  peopleForms = [],
  onPeopleFormSelectChange = () => {}
}) => {
  if (!name && !peopleForms.length) {
    return (
      <div>
        <div className="mb-1">Name</div>
        <div className="alert subtle-alert" style={{ padding: "10px 12px" }}>
          You do not have any active forms.
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={`${pcoURL(railsEnv)("people")}/forms/`}
            className="btn2 xs-btn quiet-btn ml-1"
          >
            View in People
          </a>
        </div>
      </div>
    )
  } else {
    const decoratedPeopleForms = peopleForms.map(form => {
      return {
        ...form,
        name: form.closed ? `${form.name} (Closed)` : form.name
      }
    })

    return disabled ? (
      <select
        disabled={disabled}
        css={{
          minWidth: 200,
          maxWidth: 300
        }}
        className="select"
      >
        <option key={1} value={1}>
          {name}
        </option>
      </select>
    ) : (
      <ComboBox
        placeholder="Please select"
        items={sortBy("name", decoratedPeopleForms)}
        itemKey="name"
        onSelect={onPeopleFormSelectChange}
      />
    )
  }
}

const PDFNameField = ({ disabled, name, onNameChange }) => {
  return (
    <div>
      <label className="mb-1" htmlFor="pdf_form_field">
        Name
      </label>
      <input
        disabled={disabled}
        placeholder="Name"
        autoComplete="off"
        maxLength="255"
        size="255"
        type="text"
        id="pdf_form_field"
        value={name}
        onChange={onNameChange}
      />
    </div>
  )
}

const URLFormField = ({ disabled, remoteURL, onURLChange }) => {
  return (
    <div className="mt-2">
      <label className="mb-1" htmlFor="remote_url_field">
        URL
      </label>
      <input
        disabled={disabled}
        placeholder="https://planningcenter.com"
        autoComplete="off"
        maxLength="255"
        size="255"
        type="text"
        id="remote_url_field"
        value={remoteURL}
        onChange={onURLChange}
      />
    </div>
  )
}

const SmartFormNameField = ({
  disabled,
  peopleForms,
  name,
  onNameChange,
  onURLChange,
  remoteURL,
  onPeopleFormSelectChange,
  formType = "pdf"
}) => {
  return (
    <div key={"peopleSelect"}>
      {formType === "people" && (name || !!peopleForms.length) && (
        <label className="mb-1" htmlFor={name}>
          Form Name
        </label>
      )}
      {formType === "pdf" && (
        <PDFNameField disabled={disabled} name={name} onNameChange={onNameChange} />
      )}
      {formType === "people" && (
        <PeopleFormSelectField
          disabled={disabled}
          name={name}
          id={name}
          itemKey={"name"}
          peopleForms={peopleForms}
          onPeopleFormSelectChange={onPeopleFormSelectChange}
        />
      )}
      {formType === "url" && (
        <>
          <PDFNameField disabled={disabled} name={name} onNameChange={onNameChange} />
          <URLFormField
            disabled={disabled}
            name={name}
            onURLChange={onURLChange}
            remoteURL={remoteURL}
          />
        </>
      )}
    </div>
  )
}

class PDFAttachmentField extends React.Component {
  constructor(props) {
    super(props)

    this.handlePDFUpload = this.handlePDFUpload.bind(this)
  }

  handlePDFUpload() {
    const { onPDFUpload = () => {} } = this.props
    if (this.attachment.files[0] && this.attachment.files[0].type === "application/pdf") {
      onPDFUpload(this.attachment.files[0])
    } else {
      this.attachment = null
    }
  }

  render() {
    const { attachment } = this.props
    return (
      <div className="upload-pdf-form">
        <div className="quiet-app-btn btn2 w-100% w-a@sm" css={{ maxWidth: "140px" }}>
          <div id="upload-pdf-btn-text" className="truncate">
            {attachment ? attachment.name : "Upload a PDF"}
          </div>
          <input
            ref={input => {
              this.attachment = input
            }}
            accept="application/pdf"
            type="file"
            name="form[attachment]"
            id="form_attachment"
            onChange={this.handlePDFUpload}
          />
        </div>
      </div>
    )
  }
}

export default FormForm
